import React from "react";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/style.scss";
import "./assets/scss/default/style.css";
// import Profile from "./pages/Profile";
// import AdminData from "./pages/AdminData";
// import CreatePost from "./pages/CreatePost";
import FAQ from "./pages/FAQ";
import PasswordReset from "./pages/PasswordReset";
import Auth from "./utils/auth";
// import PopularPosts from "./pages/PopularPosts";
import PasswordResetFinal from "./pages/PasswordResetFinal";
// import Test from "./pages/Test";
import ToC from "./pages/Terms";
// import Announcements from "./pages/Announcements";
import Home from "./pages/Home";
import Materials from "./pages/Materials";
import "./App.css";
import Admin from "./pages/Admin";
import CreateMaterial from "./pages/CreateMaterial";
import Profile from "./pages/Profile";

function App() {
  const loggedIn = Auth.loggedIn();
  const admin = Auth.isAdmin();

  if (!loggedIn) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Home />} />
          <Route path="/terms" element={<ToC />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/user-password-reset" element={<PasswordResetFinal />} />
        </Routes>
      </Router>
    );
  } else {
    if (admin === true || admin === "true") {
      return (
        <Router>
          <Routes>
            <Route path="/" element={<Materials />} />
            <Route path="/profile" element={<Admin />} />
            <Route path="/add-post" element={<CreateMaterial />} />
            <Route path="/contact" element={<FAQ />} />
            <Route path="/terms" element={<ToC />} />

            {/* <Route path="/popular" element={<PopularPosts />} />
            <Route path="/terms" element={<ToC />} />
            <Route path="/profile" element={<AdminData />} />
            <Route path="/admin/data" element={<AdminData />} />
            <Route path="/add-post" element={<CreatePost />} />
            <Route path="/contact" element={<FAQ />} />
            <Route path="/test" element={<Test />} /> */}
          </Routes>
        </Router>
      );
    } else {
      return (
        <Router>
          <Routes>
            <Route path="/" element={<Materials />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/add-post" element={<CreateMaterial />} />
            <Route path="/contact" element={<FAQ />} />
            <Route path="/terms" element={<ToC />} />

            {/* <Route path="/" element={<Posts />} />
          <Route path="/popular" element={<PopularPosts />} />
          <Route path="/terms" element={<ToC />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/add-post" element={<CreatePost />} />
          <Route path="/contact" element={<FAQ />} />
          <Route path="/password-reset" element={<PasswordReset />} /> */}
          </Routes>
        </Router>
      );
    }
  }
}
export default App;
